import baseAPI from "@/api/base";
import { GetCallDisposition } from "@/dtos/CallDisposition.dto";
import { GET_CALL_DISPOSITION_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

class CallDisposition {
  static getCallDispositions = async (
    getCallDisposition: GetCallDisposition
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_CALL_DISPOSITION_URL, {
      params: getCallDisposition,
    });
    return response;
  };
}

export default CallDisposition;
